import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import RegulatoryMode from "./LabServiceModel/RegulatoryMode"

export default function LabServiceRegulatoryModesGetObservable(isDOT?: boolean): Observable<RegulatoryMode[]> {
  const params = isDOT === undefined ? "" : isDOT ? "?isDOT=true" : "?isDOT=false"
  return ObservableFromFetch<RegulatoryMode[]>(`RandomTest/GetPersonnelRegulatoryModes${params}`)
}